import { Form, Input, Modal } from 'antd'
import React from 'react'
import CustomButton from '../Components/CustomButton';


const ReplyModal = ({
    openReply,
    setOpenReply,
    setReplyData,
    replyData,
    closable = true, footer = false, centered = true,
    onSubmit,
    isloading = false


}) => {
    const { TextArea } = Input;

    const handleMessageChange = (e) => {
        setReplyData({
            ...replyData,
            message: e.target.value, // Update the message in replyData
        });
    };

    return (

        <>
            {openReply && (
                <Modal
                    open={openReply}
                    onCancel={() => {
                        setOpenReply(false);
                        setReplyData({ email: '', message: '', _id: '' }); // Reset replyData
                    }}
                    closable={closable}
                    footer={footer}
                    centered={centered}
                >

                    <Form
                        layout="vertical"
                        autoComplete="off"
                        requiredMark={false}
                        className='my-8'
                    >
                        <Form.Item
                            label={<p className='font-semibold'>To</p>}
                            name="email"
                            initialValue={replyData.email}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter email!',
                                },
                            ]}

                        >
                            <Input
                                readOnly
                                className='border-0 shadow-custom '
                                size='large'
                            />
                        </Form.Item>
                        <Form.Item
                            label={<p className='font-semibold'>Message</p>}
                            name="message"
                            initialValue={replyData.message}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter reply!',
                                },
                            ]}

                        >
                            <TextArea rows={4} className="border-0 shadow-custom my-2"
                                value={replyData.message} // Bind the value to replyData.message
                                onChange={handleMessageChange} // Update the message on change
                            />
                        </Form.Item>

                        <Form.Item className='flex justify-center items-center'>

                            <CustomButton title='Send' className="mt-8 commonButton w-[12rem]  "
                                onClick={onSubmit} loading={isloading} />

                        </Form.Item>
                    </Form>


                </Modal>
            )

            }
        </>
    )
}

export default ReplyModal
